import {CostReportItem} from './types';
import {store} from '../../store/store';
import costReportReducer, {setData, updateSearchValue} from './reportSlice';

export const updateCostReportSearchValue = (value: string) => {
    store.dispatch(updateSearchValue(value));
}

export const setCostReportData = (data: Array<CostReportItem>) => {
    store.dispatch(setData(data))
}

export { costReportReducer };
